import React, { ChangeEvent, useState } from "react";
import Container from "../../components/Container";
import { MenuItem, TextField, styled } from "@mui/material";
import UserTab from "../../components/user/UserTab";
import { JobreadyContract, jobreadyAddress } from "../../web3/integrate";
import Web3 from 'web3';

import Button from "../../components/Button";


const UserProfile = () => {
  const [formStage, setFormStage] = useState(1);
  const [inputValue, setInputValue] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    skill: "",
    field: "",
    portfolio: "",
    linkedIn: "",
  });
  // const [file, setFile] = useState<File>()

  const {
    firstName,
    lastName,
    email,
    phone,
    skill,
    field,
    portfolio,
    linkedIn,
  } = inputValue;

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  async function createProfile() {
    try {
      // Estimate the gas required to execute the transaction
      const gasLimit = await JobreadyContract.estimateGas.createProfile(
        firstName, lastName, email, phone, linkedIn, skill.split(','),
        );
  
      // Create the transaction object
      const tx = await JobreadyContract.createProfile(
        phone,
        email,
        firstName,
        lastName,
        linkedIn,
        skill.split(','),
         {
        gasLimit,
      });
      const receipt = await tx.wait();
      console.log("Transaction mined. Transaction hash:", receipt.transactionHash);
      console.log("Transaction status:", receipt.status); // 1 indicates success
      console.log("Event logs:", receipt.logs);
    } catch (error) {
      console.error("Error creating profile:", error);
    }
  
  }

      
      
  // }

  // const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
  //   console.log(file)
  //   if(e.target.files) {
  //     setFile(e.target.files[0])
  //   }
  // }

  //   const handleUploadClick = () => {

  //     if(!file) {
  //       return
  //     }

  //   fetch('https://httpbin.ord/post', {
  //     method: 'POST',
  //     body: file,
  //     headers : {
  //       'content-type' : file.type,
  //       'content-length': `${file.size}`
  //     }
  //   })
  //   .then((res) => res.json())
  //   .then((data) => console.log(data))
  //   .catch((err) => console.error(err))
  // }

  // console.log(file)

  return (
    <Container>
      <UserTab />
      <div className="bg-[rgba(255,_255,_255,_0.5)] [box-shadow:_0px_2px_25px_1px_rgba(1,_126,_145,_0.05)] h-[65vh] mt-5 p-5 ">
        <div className="grid grid-cols-[40%_60%]">
          <div className="px-5">
     
            <p className="text-xl ">Chinonye Umeh</p>
            <p
              className="py-6 border-b-[0.5px] cursor-pointer"
              onClick={() => setFormStage(1)}
              style={{ color: formStage === 1 ? "#017E91" : "#151515" }}
            >
              My info
            </p>
            <p
              className="py-6 border-b-[0.5px] cursor-pointer"
              onClick={() => setFormStage(2)}
              style={{ color: formStage === 2 ? "#017E91" : "#151515" }}
            >
              My profession
            </p>
            <p
              className="py-6 border-b-[0.5px] cursor-pointer"
              onClick={() => setFormStage(3)}
              style={{ color: formStage === 3 ? "#017E91" : "#151515" }}
            >
              My wallet
            </p>
          </div>
          <div className="px-10">
            {formStage === 1 && (
              <MyInfo
                firstName={firstName}
                lastName={lastName}
                phone={phone}
                email={email}
                onChange={handleChange}
              />
            )}
            {formStage === 2 && (
              <MyProfession
                field={field}
                skill={skill}
                portfolio={portfolio}
                linkedIn={linkedIn}
                // file = {file}
                // handleUploadClick = {handleUploadClick}
                // handleFileChange = {() => handleFileChange}
                onChange={handleChange}
                createProfile={createProfile}
              />
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default UserProfile;

const MyInfo = ({
  firstName,
  lastName,
  phone,
  email,
  onChange,
}: {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}) => {
  return (
    <>

      <p className="text-xl text-main-blue">My Info</p>
      <Input
        id="firstName"
        label="First Name"
        name="firstName"
        value={firstName}
        onChange={onChange}
      />
      <Input
        id="lastName"
        label="Last Name"
        name="lastName"
        value={lastName}
        onChange={onChange}
      />
      <Input
        id="email"
        label="Email address"
        name="email"
        value={email}
        onChange={onChange}
      />
      <Input
        id="phone"
        label="Phone number"
        name="phone"
        value={phone}
        onChange={onChange}
      />
   
    </>
    
  );
};

const MyProfession = ({
  field,
  skill,
  portfolio,
  linkedIn,
  onChange,
  createProfile,
  
}: {
  skill: string
  field: string;
  portfolio: string;
  linkedIn: string;
  // file?: File,
  // handleFileChange: () => void
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  // handleUploadClick: () => void
  createProfile: () => void;
  
}) => {
  const skills = [
    {
      value: "Product Design",
      label: "Product Design",
    },
    {
      value: "Software Development",
      label: "Software Development",
    },
    {
      value: "Product Management",
      label: "Product Management",
    },
    {
      value: "Data Analysis",
      label: "Data Analysis",
    },
    {
      value: "CyberSecurity Engineering",
      label: "CyberSecurity Engineering",
    },
    {
      value: "3D Animation and Mixed Reality",
      label: "3D Animation and Mixed Reality",
    },
    {
      value: "Blockchain Engineering",
      label: "Blockchain Engineering",
    },
    {
      value: "Web Design and Development",
      label: "Web Design and Development",
    },
  ];

  const handleCreateProfile = () => {
    createProfile(); // Call the createProfile function from the prop
  };
  
  return (
    <>
      <p className="text-xl text-main-blue">My Profession</p>
      <TextField
        select
        fullWidth
        id="skill"
        label="Skill"
        size="small"
        name="skill"
        margin="normal"
        value={skill}
        onChange={onChange}
      >
        {skills.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
      <Input
        id="field"
        label="Field"
        name="field"
        value={field}
        onChange={onChange}
      />
      <Input
        id="portfolio"
        label="Portfolio"
        name="portfolio"
        value={portfolio}
        onChange={onChange}
      />
      <Input
        id="linkedin"
        label="Linkedin"
        name = "linkedIn"
        value={linkedIn}
        onChange={onChange}
      />

      <Button onClick={handleCreateProfile}>
        Create Profile
      </Button>
    </>
  );
};

export const Input = ({ id, label, name, value, onChange }: InputProps) => {
  return (
    <CssTextField
      required
      fullWidth
      id={id}
      name={name}
      label={label}
      size="small"
      margin="normal"
      value={value}
      onChange={onChange}
    />
  );
};

export const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#A0AAB4",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#B2BAC2",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#E0E3E7",
    },
    "&:hover fieldset": {
      borderColor: "#B2BAC2",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#6F7E8C",
    },
  },
});

type InputProps = {
  id: string;
  label: string;
  name: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};
